import React, { useState } from 'react';
import { FormInstance } from 'antd';
import { Form } from '@common/components';
import { StoreValue } from '@common/hooks';
import { RolesAccessPaginatedTable } from '@institutions/components';

export function SuppliersManagementViewDrawerRolesAccess({
  supplierId,
  rolesAccessEditionMode,
  form,
  onFormSubmit,
}: {
  supplierId: string;
  rolesAccessEditionMode: boolean;
  form: FormInstance;
  onFormSubmit: (values: Record<string, StoreValue>) => void;
}) {
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={() => onFormSubmit({ roleIds: selectedRowKeys })}
    >
      <Form.Item name="items">
        <RolesAccessPaginatedTable
          rolesAccessEditionMode={rolesAccessEditionMode}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          supplierId={supplierId}
        />
      </Form.Item>
    </Form>
  );
}
